import React from 'react';
import { TitleDivider } from '../title-divider';

export class Footer extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    return (
      <footer>
        <TitleDivider>Regular Institutional Partners</TitleDivider>
        <div className="footer__logos">
          { this.props.partnersInFooter.map(partner => (
            <a key={ partner.id } href={ partner.url } target="_blank">
              <img src={ partner.logo.file.url }/>
            </a>
          )) }
        </div>
      </footer>
    );
  }
}
